import type { ProfileShareKind, ProfileShareSource, ProfileShareTarget } from "~vue/api/generated/collab-profiles";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";

// Values come from coach_core's share_attribution enums via the generated API types.
// "invite" asks a colleague to set up their own profile; "own_profile" sends the sharer's profile.
export type { ProfileShareKind, ProfileShareSource, ProfileShareTarget };

// The recipient-side landing views read these back to log public_profile_share_link_clicked / _failed.
export const withShareAttribution = (url: string, source: ProfileShareSource, target: ProfileShareTarget): string => {
    const tagged = new URL(url, globalThis.location.origin);
    tagged.searchParams.set("share_source", source);
    tagged.searchParams.set("share_target", target);
    return tagged.href;
};

type ProfileSharedEvent = {
    shareSource: ProfileShareSource;
    target: ProfileShareTarget;
    shareKind: ProfileShareKind;
    access?: string;
    connectionId?: string;
    suggestionOrigin?: string;
};

// connectionId / suggestionOrigin carry over the legacy events' extra properties so they can be retired.
export const logProfileShared = ({ shareSource, target, shareKind, access, connectionId, suggestionOrigin }: ProfileSharedEvent, coachingSessionUuid?: string) =>
    logUserInteraction(
        AmplitudeEventNames.PUBLIC_PROFILE_SHARED,
        {
            share_source: shareSource,
            target,
            share_kind: shareKind,
            ...(access ? { access } : {}),
            ...(connectionId ? { connection_id: connectionId } : {}),
            ...(suggestionOrigin ? { suggestion_origin: suggestionOrigin } : {}),
        },
        coachingSessionUuid,
    );
